'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class PageTitleComponent {
  constructor($state) {
    'ngInject';

    this.$state = $state;
  }

  $onInit()  {

  }
}

export default angular.module('directives', [])
  .component('pageTitle', {
    template: require('./page-title.pug'),
    controller: PageTitleComponent,
    controllerAs: 'vm',
    bindings: {
      'title': "@"
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/page-title/page-title.component.js